<template>
  <div class="SpecificExtraWorkArchive">
    <box class="" :title="this.$t('search')">
      <div class="px-3 pt-2">
        <v-row class="mt-2">
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="auto" class="max-width-text-title px-1 d-flex">
                <label class="my-auto">{{ $t("period") }} : </label>
              </v-col>
              <v-col>
                <v-select
                  hide-details
                  v-model="period"
                  :items="periods"
                  :label="$t('period')"
                  item-text="Name"
                  item-value="Code"
                  return-object
                  dense
                  solo
                  v-on:change="changePeriod"
                  class="my-auto py-0"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="6">
            <v-row class="mt-2 mt-md-0">
              <v-col cols="auto" class="max-width-text-title px-1 d-flex">
                <label class="my-auto">{{ $t("requestType") }} : </label>
              </v-col>
              <v-col>
                <v-select
                  hide-details
                  v-model="requestType"
                  :items="requestTypes"
                  :label="$t('requestType')"
                  item-text="Name"
                  item-value="Code"
                  return-object
                  dense
                  solo
                  v-on:change="changeRequestType"
                  class="my-auto py-0"
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-card-actions class="px-0">
          <v-spacer></v-spacer>

          <v-btn min-width="100px" color="primary" @click="search">{{ $t("search") }}</v-btn>
        </v-card-actions>
      </div>
    </box>

    <box class="mt-2" :title="$t('extraWorkList')">
      <div class="">
        <div v-if="list.length > 0">
          <person-specific-extra-work-list-web
            @onClick="onClickSEW"
            :list="list"
            class="hidden-sm-and-down"
          />
          <person-specific-extra-work-list-mob
            @onClick="onClickSEW"
            :list="list"
            class="hidden-md-and-up"
          />

          <div class="text-center">
            <v-pagination
              v-model="page"
              :length="pages"
              :total-visible="5"
              @input="search"
            ></v-pagination>
          </div>
        </div>
        <div v-else>
          <EmptyList />
        </div>
      </div>
    </box>

    <specific-extra-work-archive-details
      ref="ArchiveDetails"
      @refresh="search"
    />
  </div>
</template>

<script>
import PersonSpecificExtraWorkListMob from "../../components/request/PersonSpecificExtraWorkList/PersonSpecificExtraWorkListMob.vue";
import PersonSpecificExtraWorkListWeb from "../../components/request/PersonSpecificExtraWorkList/PersonSpecificExtraWorkListWeb.vue";
import SpecificExtraWorkArchiveDetails from "../../components/request/SpecificExtraWorkArchiveDetails.vue";
export default {
  components: {
    PersonSpecificExtraWorkListWeb,
    PersonSpecificExtraWorkListMob,
    SpecificExtraWorkArchiveDetails,
  },
  data() {
    return {
      pages: 1,
      page: 1,
      pagesize: 20,
      period: "",
      periods: [],
      requestType: "",
      requestTypes: [],
      list: [],
    };
  },
  mounted() {
    this.setPeriods();
    this.setRequestTypes();
    this.search();
  },
  methods: {
    setRequestTypes() {
      this.requestTypes.push({
        Name: this.$t("RequestType.NewRequest"),
        Code: "1",
      });
      this.requestTypes.push({
        Name: this.$t("RequestType.ConfirmRequest"),
        Code: "2",
      });
      this.requestTypes.push({
        Name: this.$t("RequestType.ReturnRequest"),
        Code: "4",
      });
      this.requestTypes.push({
        Name: this.$t("RequestType.AllRequest"),
        Code: "5",
      });

      this.requestType = this.requestTypes[0];
    },
    setPeriods() {
      this.periods.push({ Name: this.$t("AllPeriod"), Code: "" });
      this.periods.push({ Name: "1", Code: "1" });
      this.periods.push({ Name: "2", Code: "2" });
      this.periods.push({ Name: "3", Code: "3" });
      this.periods.push({ Name: "4", Code: "4" });
      this.periods.push({ Name: "5", Code: "5" });
      this.periods.push({ Name: "6", Code: "6" });
      this.periods.push({ Name: "7", Code: "7" });
      this.periods.push({ Name: "8", Code: "8" });
      this.periods.push({ Name: "9", Code: "9" });
      this.periods.push({ Name: "10", Code: "10" });
      this.periods.push({ Name: "11", Code: "11" });
      this.periods.push({ Name: "12", Code: "12" });

      this.period = this.periods[0];
    },
    changePeriod() {
      this.search();
    },
    changeRequestType() {
      this.search();
    },
    search() {
      //console.log(this.requestType.Code);
      var GetPersonSpecificEwParams = {
        status: this.requestType.Code,
        periodItem: this.period.Code,
        page: this.page,
        pagesize: this.pagesize,
      };
      this.$store
        .dispatch("GetPersonSpecificEw", { GetPersonSpecificEwParams })
        .then((result) => {
          //console.log(result);
          if (result.response.TotalRow) {
            this.pages = Math.ceil(result.response.TotalRow / this.pagesize);
            //console.log(this.pages);
          }
          this.list = result.data;
        });
    },
    onClickSEW(item) {
      this.$refs.ArchiveDetails.show(item);
    },
  },
};
</script>

<style scoped>
.max-width-text-title {
  width: 100px;
}
</style>